import { LitElement, html, unsafeCSS } from "lit";
import nysLogo from "./nys-unav.logo";
// @ts-ignore: SCSS module imported via bundler as inline
import styles from "./nys-unavfooter.scss?inline";

/**
 * Universal NYS footer with logo and statewide navigation links. Required on all NYS sites.
 *
 * Place as the last element before `</body>`. Displays NY.gov logo and links to Agencies,
 * App Directory, Counties, Events, Programs, and Services. No configuration needed.
 *
 * @summary Universal NYS footer with logo and statewide links. Required site-wide.
 * @element nys-unavfooter
 *
 * @example Standard usage
 * ```html
 * <nys-globalfooter>...</nys-globalfooter>
 * <nys-unavfooter></nys-unavfooter>
 * ```
 */

export class NysUnavFooter extends LitElement {
  static styles = unsafeCSS(styles);

  /**
   * Functions
   * --------------------------------------------------------------------------
   */

  private _getNysLogo() {
    if (!nysLogo) return null;

    // Parse the SVG string into an actual SVG DOM element
    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(nysLogo, "image/svg+xml");
    const svgElement = svgDoc.documentElement;

    return svgElement;
  }

  render() {
    return html`
      <footer class="nys-unavfooter">
        <div class="nys-unavfooter__main-container">
          <div class="nys-unavfooter__container_menu">
            <div class="nys-unavfooter__logo">
              <a
                href="https://www.ny.gov"
                target="_blank"
                id="nys-unavheader__logolink"
                aria-label="logo of New York State"
                >${this._getNysLogo()}</a
              >
            </div>
            <div class="nys-unavfooter__content">
              <ul>
                <li><a href="https://www.ny.gov/agencies">Agencies</a></li>
                <li>
                  <a href="https://www.ny.gov/mobileapps">App Directory</a>
                </li>
                <li><a href="https://www.ny.gov/counties">Counties</a></li>
                <li><a href="https://www.ny.gov/events">Events</a></li>
                <li><a href="https://www.ny.gov/programs">Programs</a></li>
                <li><a href="https://www.ny.gov/services">Services</a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    `;
  }
}

if (!customElements.get("nys-unavfooter")) {
  customElements.define("nys-unavfooter", NysUnavFooter);
}
